import React from "react";
import { Box, Flex, Heading, Text, Link } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

const CourseDetailsHero = () => {
  const navigate = useNavigate();
  return (
    <Box 
      bg="#25575F"
      minH={{ base: "180px", sm: "200px", md: "220px", lg: "280px" }}
      pb={{ base: 4, md: 6, lg: 8 }} 
      px={{ base: 4, md: 12, lg: 24 }} 
      position="relative"
      bgImage="url('/png/career-header.png')"
      bgSize={{ base: "80%", md: "70%" }}
      bgPosition={{ base: "center", md: "center" }}
      bgRepeat="no-repeat"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      {/* Breadcrumb */}
      <Flex align="center" pt={{ base: 6, md: 8 }}>
        <Flex align="center" cursor="pointer" onClick={() => navigate('/careers')}>
          <ArrowBackIcon mr={1} color="#C8E6E6" fontSize={{ base: "lg", md: "xl" }} />
          <Link 
            color="#E6F2F3" 
            fontWeight="500" 
            textDecor="underline"
            fontSize={{ base: "sm", md: "md" }}
          >
            Career
          </Link>
        </Flex>
        <Text color="#E6F2F3" mx={2} fontSize={{ base: "lg", md: "xl" }}>/</Text>
        <Text 
          color="#E6F2F3" 
          fontWeight="400"
          fontSize={{ base: "sm", md: "md" }}
        >
          Course Details
        </Text>
      </Flex>
      {/* Title & Subtitle */}
      <Box 
        textAlign="center" 
        position="relative" 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center"
        flex="1"
        py={{ base: 6, md: 8 }}
      >
        <Heading
          as="h1"
          fontSize={{ base: "2xl", sm: "3xl", md: "4xl", lg: "5xl" }}
          fontWeight="bold"
          color="#E6FF2B"
          mb={{ base: 3, md: 4 }}
          zIndex={2}
          lineHeight="1.1"
          px={{ base: 2, md: 0 }}
        >
          Course Details
        </Heading>
        <Text 
          fontSize={{ base: "sm", sm: "md", md: "xl", lg: "2xl" }} 
          color="white" 
          zIndex={2}
          maxW={{ base: "90%", md: "70%" }}
          px={{ base: 2, md: 0 }}
        >
          Grow your abilities grow your career
        </Text>
      </Box>
    </Box>
  );
};

export default CourseDetailsHero; 